// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__KXljr","itemsWrapper":"styles_itemsWrapper__0f5qp","item":"styles_item__C_DVs","download":"styles_download__hiDrd"};